import React, { Component } from 'react';
import LocationSearchInput from './locationSearchInput';
import EditLocation from './editLocation';

class getNewUbication extends Component {
  constructor(){
    super();
    this.state = {
        modulo_modal : '',
        lat:0,
        lng:0,
        msg_loading :false,
        name:''
    }
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  get_go_to =(modulo_modal,lat,lng,name)=>{
    this.setState({
      modulo_modal,lat,lng,name
    })
  }
  get_finalice_to =(lat,lng,name,id_ubicacion)=>{
    this.props.get_coordenadas(lat,lng,name,id_ubicacion)
  }
  render() {
    const modulo_modal = this.state.modulo_modal
    let dir_modulo_modal
    if(modulo_modal===''){
      dir_modulo_modal = <React.Fragment><LocationSearchInput get_go_to={this.get_go_to} get_go_to_step={this.props.get_go_to} /></React.Fragment>
    }
    if(modulo_modal==='StepNewUbication'){
      dir_modulo_modal = <React.Fragment><EditLocation get_go_to={this.get_go_to}  get_finalice_to={this.get_finalice_to} get_loading={this.get_loading} lat={this.state.lat} lng={this.state.lng} name={this.state.name} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}/></React.Fragment>
    }
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    return (
      <React.Fragment>
        {dir_modulo_modal}
        {modal_loading}
      </React.Fragment>
    );
  }
}
export default getNewUbication;
